import Storage from './Storage';

/**
 * Store CityList
 * 
 */
class CityList extends Storage {
    storeName = 'city_list_';
    hasOldKey = true;

    /**
     * CityList constructor
     * 
     * @param {string} id client id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        let returnData = JSON.stringify({
            'data': (data.data.data) ? data.data.data : null,
            'type': (data.data.type) ? data.data.type : 'default',
            'success' : data.data.success
        });
        return returnData;
    }

}

export default CityList;